import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import {
  Affix,
  Button,
  Col,
  Descriptions,
  Divider,
  Modal,
  Row,
  Space,
  Spin,
  Typography,
  Upload
} from 'antd';
import React, { useEffect, useState } from 'react';
import { Document, Page } from 'react-pdf';
import { SizeMe } from 'react-sizeme';
import CardDocumentPreview360 from '../../../../../components/CardDocumentPreview360';
import Image360 from '../../../../../components/Image360';
import ResponsiveContainer from '../../../../../components/ResponsiveContainer';
import { CONFIG } from '../../../../../constants';
import { useSiniestroContext } from '../../../../../context/siniestro-context';
import Camara from '../../../../../static/autos/Camara.jpg';
import { errorHandler } from '../../../../../utils';
import { instanceRef } from '../../../../../utils/axios';
import { cardsPatrimoniales } from '../CarUtil';
import TarjetaEdit from '../TarjetaEdit';

const { Title } = Typography;

function ResumenPatrimoniales(props) {
  const { datosSiniestro, getImages, updateSiniestro } = useSiniestroContext();
  const [loading, setLoading] = useState(false);
  const [imagenes, setImagenes] = useState([]);
  const [finalizarDisable, setFinalizarDisable] = useState(true);
  const [cards, setCards] = useState(cardsPatrimoniales);
  const [documentos, setDocumentos] = useState(null);
  const [fotosDocumentos, setFotosDocumentos] = useState(null);
  const [cantfotos, setCantfotos] = useState(0);
  const [numPages, setNumPages] = useState(null);
  const [dialogConfig, setDialogConfig] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  const { back } = props;

  const countFotos = async () => {
    const imagenesNews = await getImages(datosSiniestro);
    const cont = imagenesNews.length;
    setCantfotos(cont);
    if (cont >= 2) {
      setFinalizarDisable(false);
    }
  };

  const getImagenes = async () => {
    setLoading(true);
    const newCards = cardsPatrimoniales;

    const imagenesNews = await getImages(datosSiniestro);
    setImagenes(imagenesNews);
    const cant = imagenesNews.length;
    // imagenes adicionales
    const adicionales = [];
    const auxAdicional = imagenesNews.filter((e) => e.paso_nro > 2);
    auxAdicional.forEach((e) => {
      adicionales.push({
        item: `${e.paso_nro}`,
        key: e.paso_nro,
        image: Camara,
        parte: 'Fotografía Adicional',
        check: false
      });
    });

    setCards([...newCards, ...adicionales]);
    setCantfotos(cant);
    if (cant >= 2) {
      setFinalizarDisable(false);
    }
    setLoading(false);
  };

  const getSiniestroFiles = async (siniestro) => {
    setLoading(true);
    try {
      const files = await instanceRef.instance.get(
        `/siniestro/files/${siniestro.token}?sinform=true`
      );
      const baseURL = CONFIG.URL_BASE;
      const docs = files.data.data.map((item) => ({
        ...item,
        url: `${baseURL}/siniestro/file/${siniestro.token}?id=${item.id}`
      }));
      setFotosDocumentos(docs.filter((e) => !e.descripcion.includes('pdf')));
      setDocumentos(docs.filter((e) => e.descripcion.includes('pdf')));
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const goTo = async () => {
    props.continueStep();
  };

  const finalizar = async () => {
    try {
      await await updateSiniestro({ etapa: 'FOTOS_SUBIDAS' });
      props.next();
    } catch (err) {
      errorHandler(err);
    }
  };

  function onDocumentLoadSuccess() {
    setNumPages(numPages);
  }

  const nextPage = () => {
    if (currentPage < numPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const previousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    getImagenes();
    getSiniestroFiles(datosSiniestro);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <Spin
        spinning={loading}
        delay={500}
        tip="Cargando Fotos..."
        style={{ paddingTop: 24 }}
      >
        <div className="content" />
      </Spin>
    );
  }
  return (
    <>
      <ResponsiveContainer size="large">
        <Descriptions title="" style={{ textAlign: 'left' }}>
          <Descriptions.Item label="">
            Favor verificar las fotografías y documentos cargados, en caso que
            desee subir los mismos y finalizar el proceso, dar click en
            finalizar.
          </Descriptions.Item>
        </Descriptions>
        <Title level={4}>Fotos del Patrimonio Asegurado</Title>
        <div style={{ textAlign: 'left' }}>
          <>
            <Row gutter={[32, 32]}>
              {cards.map((card) => (
                <TarjetaEdit
                  card={card}
                  key={card.key}
                  imagenes={imagenes}
                  siniestro={datosSiniestro}
                  count={countFotos}
                />
              ))}
            </Row>
          </>
        </div>
        <Title level={4} style={{ marginTop: '20px' }}>
          Documentos
        </Title>
        <Divider>Fotografías</Divider>
        {fotosDocumentos && !fotosDocumentos.length && <p>Sin datos</p>}
        <Row gutter={[16, 16]} justify="center" align="middle">
          {fotosDocumentos &&
            fotosDocumentos.map((imagen) => (
              <Col key={imagen.url}>
                <div>
                  <Upload
                    name="avatar"
                    listType="picture-card"
                    className={`avatar-uploader success'`}
                    showUploadList={false}
                    disabled
                  >
                    <Image360
                      style={{
                        width: 'auto !important',
                        borderColor: 'red',
                        height: '40%'
                      }}
                      src={imagen.url}
                      alt="avatar"
                    />
                  </Upload>
                </div>
              </Col>
            ))}
        </Row>
        <Divider>Archivos</Divider>
        {documentos && !documentos.length && <p>Sin datos</p>}
        <div>
          <Row gutter={[16, 16]} justify="center" align="middle">
            {documentos &&
              documentos.map((doc) => (
                <Col>
                  <CardDocumentPreview360
                    key={doc.url}
                    cardProps={{
                      onClick: () => {
                        setDialogConfig({
                          open: true,
                          content: doc.url,
                          title: ''
                        });
                      }
                    }}
                    documentProps={{
                      file: doc.url,
                      onLoadSuccess: onDocumentLoadSuccess
                    }}
                  />
                </Col>
              ))}
          </Row>{' '}
          <Modal
            bodyStyle={{ padding: 0, paddingBottom: 20 }}
            style={{ maxWidth: 1000 }}
            className="modal-header-document"
            centered
            open={dialogConfig.open}
            afterClose={() =>
              setDialogConfig({
                open: false,
                content: undefined,
                title: ''
              })
            }
            onCancel={() =>
              setDialogConfig({
                open: false,
                content: undefined,
                title: ''
              })
            }
            footer={null}
            width="90%"
          >
            <div>
              {dialogConfig.content && (
                <SizeMe>
                  {({ size }) => (
                    <Document
                      onLoadSuccess={onDocumentLoadSuccess}
                      loading={<Spin />}
                      file={dialogConfig.content}
                    >
                      <Page
                        key={`page_${currentPage + 1}`}
                        pageNumber={currentPage + 1}
                        width={size.width ? size.width : 1}
                      />
                      <div style={{ textAlign: 'center' }}>
                        <Button
                          type="link"
                          onClick={() => previousPage()}
                          disabled={currentPage === 0}
                        >
                          <LeftOutlined />
                          Anterior
                        </Button>
                        Pág. {currentPage + 1} de {numPages}
                        <Button
                          type="link"
                          onClick={() => nextPage()}
                          disabled={currentPage + 1 === numPages}
                        >
                          Siguiente
                          <RightOutlined />
                        </Button>
                      </div>
                    </Document>
                  )}
                </SizeMe>
              )}
            </div>
          </Modal>
          <Row style={{ margin: '0px 30px 0px 30px' }}>
            <Col
              xs={24}
              sm={24}
              style={{ margin: '10px', justifyContent: 'space-between' }}
            >
              {' '}
            </Col>
          </Row>
        </div>

        <Space>
          <Button onClick={back}>Anterior</Button>
          <Button
            disabled={finalizarDisable}
            onClick={() => finalizar()}
            type="primary"
          >
            Finalizar
          </Button>
        </Space>
      </ResponsiveContainer>
      {cantfotos < 2 && (
        <Affix offsetBottom={20} style={{ position: 'fixed', left: 20 }}>
          <Button type="primary" onClick={() => goTo()}>
            Continuar
          </Button>
        </Affix>
      )}
    </>
  );
}

export default ResumenPatrimoniales;
